import { Component, HostListener, Input, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CacheService } from 'src/app/services/cache.service';
import { ConstantsService } from 'src/app/services/constants.service';
import { UserService } from 'src/app/services/user.service';
// import { HelperService } from 'src/app/services/helper.service';

@Component({
  selector: 'app-user-setting',
  templateUrl: './user-setting.component.html',
  styleUrls: ['./user-setting.component.scss']
})
export class UserSettingComponent implements OnInit, OnDestroy {
  public editProfile = true;
  public changePassword = false;
  public allAccess = false;
  public closeAccount = false;
  public from = 'userSetting';
  public editProfileMobile = false;
  public isMobile = false;
  public emailAddress = 'hello@window-swap.com';
  prime: any = false;
  subscriptionId: any;
  screenHeight: number;
  screenWidth: number;
  windowWidth: string;
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 576 && this.screenWidth < this.screenHeight) {
      this.windowWidth = `${this.screenHeight}px`;
    }
  }
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public constants: ConstantsService,
    private deviceService: DeviceDetectorService,
    private cache: CacheService,
    public userService: UserService,
    // private helperService:HelperService
  ) {
    this.isMobile = this.deviceService.isMobile();
    this.router.navigate(['/user-setting']), { relativeTo: this.route };
  }

  ngOnInit(): void {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.addGlobalStyle('.publift-widget-23174194645-container,.publift-widget-23196941527-container { display: none !important}');
    this.authcall();
    this.onResize();
  }

  ngOnDestroy(): void {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.removeGlobalStyle();
  }
  
  async authcall() {
    await this.cache.getAuthUser()
      .then(async data => {
        await this.userService.getUser(true).then(res => {
          let { isPrime, subscriptionId } = res;
          this.prime = isPrime;
          this.subscriptionId = subscriptionId === null ? false : true;
        })
      })
  }
  editprofile() {
    this.editProfile = true;
    this.isMobile === true ? this.editProfileMobile = true : this.editProfileMobile = false;
    this.changePassword = false;
    this.allAccess = false;
    this.closeAccount = false;
    this.router.navigate(['/user-setting']), { relativeTo: this.route };
  }
  changepassword() {
    this.changePassword = true;
    this.isMobile === true ? this.editProfileMobile = true : this.editProfileMobile = false;
    this.editProfile = false;
    this.allAccess = false;
    this.closeAccount = false;
    this.router.navigate(['/user-setting/change-password']), { relativeTo: this.route };
  }
  allaccess() {
    this.allAccess = true;
    this.isMobile === true ? this.editProfileMobile = true : this.editProfileMobile = false;
    this.editProfile = false;
    this.changePassword = false;
    this.closeAccount = false;
    this.router.navigate(['/user-setting/all-access']), { relativeTo: this.route };
  }
  closeaccount() {
    this.closeAccount = true;
    this.isMobile === true ? this.editProfileMobile = true : this.editProfileMobile = false;
    this.editProfile = false;
    this.changePassword = false;
    this.allAccess = false;
    this.router.navigate(['/user-setting/close-account']), { relativeTo: this.route };
  }

  toMenu() {
    this.editProfileMobile = false;
  }

}
